<footer>
  <div>
    <p>&copy; {{copyrightYear}} Hubio Technology</p>
  </div>
</footer>